export default {
    bindings: {
        getAvailability: '&'
    },
    controller: 'guestInputModalController',
    template: require('../views/guest.input.modal.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/guest.input.modal.component.js